import { useMemo } from 'react';
import { Grid } from '@material-ui/core';
import { EntityGrafanaAlertsCard } from '@backstage-community/plugin-grafana';
import { stringifyEntityRef } from '@backstage/catalog-model';
import { EntityProvider, useEntity } from '@backstage/plugin-catalog-react';
import { usePlatformHealth } from '../health/api';

/**
 * Алерты Grafana сервиса. Правила помечаются меткой service=<имя сущности>, поэтому аннотация
 * grafana/alert-label-selector в catalog-info.yaml не нужна: подставляем её сами. Карточка видна
 * только у сущностей, у которых есть такие правила (по данным «Здоровья платформы»).
 */
export const EntityAlertsCard = () => {
  const { entity } = useEntity();
  const { value } = usePlatformHealth();
  const ref = stringifyEntityRef(entity);
  const rules =
    value?.entities.find(e => e.entityRef === ref)?.alerts.rules ?? 0;

  const withSelector = useMemo(
    () => ({
      ...entity,
      metadata: {
        ...entity.metadata,
        annotations: {
          ...entity.metadata.annotations,
          'grafana/alert-label-selector': `service=${entity.metadata.name}`,
        },
      },
    }),
    [entity],
  );

  if (!rules) return null;
  return (
    <Grid item md={6} xs={12}>
      <EntityProvider entity={withSelector}>
        <EntityGrafanaAlertsCard title="Алерты Grafana" showState />
      </EntityProvider>
    </Grid>
  );
};
